import React, { useRef, useEffect, useState } from 'react';
import Map, { Source, Layer, Marker, Popup } from 'react-map-gl';
import Legend from './Legend';
import AreaChart from './AreaChart';
import electionUrl from './election.geojson';
const electionData = require('./election.geojson');

const path = process.env.PUBLIC_URL

const MapChart = () => {
  const mapRef = useRef();
  const tooltipRef = useRef();
  const [currentProperty, setCurrentProperty] = useState('demoIndex');
  const [tooltipInfo, setTooltipInfo] = useState(null);
  const [currentCategory, setCurrentCategory] = useState('');
  const [isChecked, setIsChecked] = useState(false);

  const [geojson, setGeojson] = useState(null);

  useEffect(() => {
    // Fetch GeoJSON data (or use it directly if already available)
    fetch(electionData)
      .then(response => response.json())
      .then(data => setGeojson(data))
      .catch(error => console.error('Error fetching GeoJSON:', error));
  }, []);

  const breakpoint = 768;

  const getProjection = () => {
    const windowWidth = window.innerWidth;
    if (windowWidth < breakpoint) {
      return 'globe';
    } else {
      return 'equirectangular';
    }
  }

  const getZoom = () => {
    const windowWidth = window.innerWidth;
    if (windowWidth < breakpoint) {
      return 1;
    } else {
      return 1 + (windowWidth - breakpoint) / (breakpoint + 20);
    }
  }

  const getHeight = () => {
    const windowWidth = window.innerWidth;
    if (windowWidth < breakpoint) {
      return "100vw";
    } else {
      return "55vw";
    }
  }

  const getDragPan = () => {
    const windowWidth = window.innerWidth;
    if (windowWidth < breakpoint) {
      return true;
    } else {
      return false;
    }
  }

  const [initialViewState, setViewport] = useState({
    zoom: getZoom(),
    projection: getProjection(), //'mercator'
    renderWorldCopies: false,
    scrollZoom: false,
    dragPan: getDragPan(),
  });

  const [mapHeight, setHeight] = useState(getHeight());

  const handleMarkerHover = (event, feature) => {
    if (!event || !feature) return;
    // const { lngLat: coordinates } = event;
    const coordinates = event.lngLat;
    console.log(coordinates);
    setTooltipInfo({ coordinates, feature });
  };

  const handleMarkerLeave = () => {
    setTooltipInfo(null);
  };

  const handleMapMouseMove = (event, id) => {
    const map = mapRef.current;
    const features = map?.queryRenderedFeatures(event.point, { layers: [id] });

    if (features?.length > 0) {
      const feature = features[0];
      handleMarkerHover(event, feature);
    } else {
      handleMarkerLeave();
    }
  };

  const handleToggle = () => {
    setIsChecked(!isChecked);
  };

  const buttonConfigs = [
    // { label: '民主排名', value: 'demoRank', desc: '2023年英国《经济学人》发布的评价全球167个政权民主程度的民主指数排名。民主指数分数越高，则民主排名越靠前。', color: '#F0D9EE' },
    { 
      "label": "Democracy Index", 
      "value": "demoIndex", 
      "desc": "A global democracy score by The Economist, assessing 167 governments based on elections, governance, participation, political culture, and civil liberties. Published in 2023.", 
      "color": "#E2F5E8" 
    },
    { 
        "label": "Fair Elections Index", 
        "value": "equalIndex", 
        "desc": "V-Dem’s expert-based rating of election fairness, measuring violence, intimidation, fraud, and vote-buying. Scale: 0 to 1 (higher = fairer).", 
        "color": "#F5EFD5" 
    },
    { 
        "label": "Democracy Category", 
        "value": "classification", 
        "desc": "The Economist categorizes governments into full democracies, flawed democracies, hybrid regimes, and authoritarian regimes.", 
        "color": "#F8ECEC" 
    }
  ];

  const legendConfigs = {
    demoRank:  [
      { label: '0', color: '#FF57F8' },
      { label: '165', color: '#000' },
    ],
    demoIndex:  [
      { label: '0', color: '#1A0619' },
      { label: '10', color: '#0BFF50' }
    ],
    equalIndex:  [
      { label: '0', color: '#000' },
      { label: '1', color: '#FFDD29' }
    ],
    classification:  [
      { label: 'Full Democracy', color: '#06ED47' },
      { label: 'Flawed Democracy', color: '#EEE50E' },
      { label: 'Hybrid Regime', color: '#D77D29' },
      { label: 'Authoritarian Regime', color: '#EC1D1D' }
    ]
  }
    

  const layers = [
    // {
    //   id: 'clusters',
    //   type: 'circle',
    //   source: 'election',
    //   filter: ['!=', ['get', 'demoRank'], null],
    //   paint: {
    //     'circle-color': [
    //       'interpolate',
    //       ['linear'],
    //       ['get', 'demoRank'], // Property to interpolate (demoRank in this case)
    //       0, '#FF57F8', // Color at value 0
    //       165, '#000' // Color at value 1
    //     ],
    //     'circle-opacity': 0.7,
    //     'circle-stroke-color': [
    //       'interpolate',
    //       ['linear'],
    //       ['get', 'demoRank'], // Property to interpolate (demoRank in this case)
    //       0, '#FF57F8', // Color at value 0
    //       165, '#000' // Color at value 1
    //     ],
    //     'circle-stroke-width': 1,
    //     'circle-radius': [
    //       'sqrt',
    //       ['interpolate', ['linear'], ['get', 'population'], 1, 10, 1440, 14400]
    //     ],
    //   }
    // },
    {
      id: 'clusters',
      type: 'circle',
      source: 'election',
      // filter: ['!=', ['get', 'demoIndex'], null],
      filter: [
        'all',
        ['!=', ['get', 'demoIndex'], null], // Filter for demoIndex not being null
        currentCategory !== "" ? [currentCategory === "" ? '>=' : '!=', ['get', currentCategory], 0] : null // Conditionally add category filter
      ].filter(Boolean),
      paint: {
        'circle-color': [
          'interpolate',
          ['linear'],
          ['get', 'demoIndex'], // Property to interpolate (demoIndex in this case)
          0, '#1A0619', // Color at value 0
          10, '#0BFF50' // Color at value 1
        ],
        'circle-opacity': 0.7,
        'circle-stroke-color': [
          'interpolate',
          ['linear'],
          ['get', 'demoIndex'], // Property to interpolate (demoIndex in this case)
          0, '#1A0619', // Color at value 0
          10, '#0BFF50' // Color at value 1
        ],
        'circle-stroke-width': 1,
        'circle-radius': [
          'sqrt',
          ['interpolate', ['linear'], ['get', 'population'], 1, 10, 1440, 14400]
        ],
      }
    },
    {
      id: 'clusters',
      type: 'circle',
      source: 'election',
      filter: [
        'all',
        ['!=', ['get', 'equalIndex'], null], // Filter for demoIndex not being null
        currentCategory !== "" ? [currentCategory === "" ? '>=' : '!=', ['get', currentCategory], 0] : null // Conditionally add category filter
      ].filter(Boolean),
      paint: {
        'circle-color': [
          'interpolate',
          ['linear'],
          ['get', 'equalIndex'], // Property to interpolate (demoIndex in this case)
          0, '#000', // Color at value 0
          1, '#FFDD29' // Color at value 1
        ],
        'circle-opacity': 0.7,
        'circle-stroke-color': [
          'interpolate',
          ['linear'],
          ['get', 'equalIndex'], // Property to interpolate (demoIndex in this case)
          0, '#000', // Color at value 0
          1, '#FFDD29' // Color at value 1
        ],
        'circle-stroke-width': 1,
        'circle-radius': [
          'sqrt',
          ['interpolate', ['linear'], ['get', 'population'], 1, 10, 1440, 14400]
        ],
      }
    },
    {
      id: 'clusters',
      type: 'circle',
      source: 'election',
      filter: [
        'all',
        ['!=', ['get', 'classification'], null], // Filter for demoIndex not being null
        currentCategory !== "" ? [currentCategory === "" ? '>=' : '!=', ['get', currentCategory], 0] : null // Conditionally add category filter
      ].filter(Boolean),
      paint: {
        'circle-color': [
          'match',
          ['get', 'classification'],
          'Full Democracy', '#06ED47',
          'Flawed Democracy', '#EEE50E',
          'Hybrid Regime', '#D77D29',
          'Authoritarian Regime', '#EC1D1D',
          '#000000' // Default color if no match
        ],
        'circle-opacity': 0.7,
        'circle-stroke-color': [
          'match',
          ['get', 'classification'],
          'Full Democracy', '#06ED47',
          'Flawed Democracy', '#EEE50E',
          'Hybrid Regime', '#D77D29',
          'Authoritarian Regime', '#EC1D1D',
          '#000000' // Default color if no match
        ],
        'circle-stroke-width': 1,
        'circle-radius': [
          'sqrt',
          ['interpolate', ['linear'], ['get', 'population'], 1, 10, 1440, 14400]
        ],
      }
    }
  ];

  // add country name to map
  const countryLayer = {
    id: 'country',
    type: 'symbol',
    source: 'election',
    layout: {
      'text-field': ['get', 'country_cn'],
      'text-font': ['Open Sans Regular'],
      'text-size': 12,
    },
    paint: {
      'text-color': '#444',
      'text-halo-color': 'rgba(255, 255, 255, 0.7)', // Outline color
      'text-halo-width': 0.8, 
    },
  };

  const center = [16, 5];

  useEffect(() => {
    const layer = clusterLayer;
    if (currentCategory !== "") {
      const updatedLayers = {
        ...layer,
        filter: ['all', ['!=', ['get', currentProperty], null], [currentCategory === "" ? '>=' : '!=', ['get', currentCategory], 0]]
      };
      // Update state to trigger re-render with updated layers
      setClusterLayer(updatedLayers);
    } else {
      const updatedLayers = {
        ...layer,
        filter: ['!=', ['get', currentProperty], null],
      };
      // Update state to trigger re-render with updated layers
      setClusterLayer(updatedLayers);
    }
  }, [currentCategory]);

  const [clusterLayer, setClusterLayer] = useState(layers[0]);

  const handleCategoryChange = (event) => {
    setCurrentCategory(event.target.value);
  };

  return (
    <>
      <div className="navigation">
        <div className="navigation-wrapper">
          {buttonConfigs.map((button, index) => (
            <button
              key={index}
              onClick={() => { setClusterLayer(layers[index]); setCurrentProperty(button.value);}}
              className={ currentProperty === button.value ? "selected" : ""}
            >
              {button.label}
            </button>
          ))}
          <select value={currentCategory} onChange={handleCategoryChange}>
            <option value="">Election Type --</option>
            <option value="president">Presidential</option>
            <option value="parliament">Parliamentary</option>
            <option value="presidential_parliament">Legislative</option>
          </select>
          <>
            <input
              checked={isChecked}
              onChange={() => setIsChecked(!isChecked)}
              className="react-switch-checkbox"
              id={`react-switch-new`}
              type="checkbox"
            />
            <label
              // style={{ background: isChecked && '#513D9E' }}
              className="react-switch-label"
              htmlFor={`react-switch-new`}
            >
              <span className={`react-switch-button`} />
              <div className='react-switch-content'>
                <span className='react-switch-left' style={{ color: isChecked && '#513D9E' }}>Map</span>
                <span className='react-switch-right' style={{ color: !isChecked && '#513D9E' }}>Bar</span></div>
            </label>
          </>
          <div className='desc-wrapper'>
            <div className='desc' style={{ backgroundColor: buttonConfigs.find(button => button.value === currentProperty).color }}>
              {buttonConfigs.find(button => button.value === currentProperty).desc}
            </div>
            <div className="legend" style={{ backgroundColor: buttonConfigs.find(button => button.value === currentProperty).color }}>
              {legendConfigs[currentProperty].map((stop, index) => (
                <div key={index} className="legend-item">
                  <div className="gradient-color" style={{ backgroundColor: stop.color }} />
                  <span className="legend-text">{stop.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="map__container">
        <Map
          ref={mapRef}
          mapboxAccessToken="pk.eyJ1IjoidmljdG9yaWFqIiwiYSI6ImNseHAzeDE1cDA2aWcyd3BrdXI0dHd1aHAifQ.GtBMI7UbB6Q_HlVEuL9Ygg"
          {...initialViewState}
          style={{width: "100vw", height: mapHeight, opacity: isChecked ? 0 : 1, transition: "opacity 0.5s", pointerEvents: isChecked ? "none" : "auto"}}
          mapStyle="mapbox://styles/victoriaj/cm713bxmp003e01quah7a08r0"
          onLoad={() => {
            mapRef.current.setCenter(center);
          }}
          onResize={() => {
            const windowWidth = window.innerWidth;
            if (windowWidth < breakpoint) {
              setViewport({
                ...initialViewState,
                projection: 'globe',
                zoom: 1,
                dragPan: true,
              })
              setHeight("100vw");
              mapRef.current.setCenter(center);
            } else {
              setViewport({
                ...initialViewState,
                projection: 'equirectangular',
                zoom: 1 + (windowWidth - breakpoint) / (breakpoint + 20),
                dragPan: false,
              })
              setHeight ("55vw");
              mapRef.current.setCenter(center);
            }
            mapRef.current.triggerRepaint();
            console.log(mapRef.current);
          }
        }
        onMouseMove={(event) => handleMapMouseMove(event, "clusters")}
      >
        <Source
          id="circle-source"
          type="geojson"
          data={electionData}
          cluster={true}
          clusterMaxZoom={1}
          clusterRadius={1}
        >
          <Layer
            {...clusterLayer}
            onMouseEnter={(e) => handleMarkerHover(e, /* demoRank */)}
            onMouseLeave={() => handleMarkerLeave()}
          />
          <Layer {...countryLayer} />
        </Source>
        {tooltipInfo && (
          <Popup
            latitude={tooltipInfo.coordinates.lat}
            longitude={tooltipInfo.coordinates.lng}
            closeButton={false}
          >
            <h3>{tooltipInfo.feature.properties.country}</h3>
            Population: {parseInt(tooltipInfo.feature.properties.population)}M
            <br/>
            Per Capita GDP: {tooltipInfo.feature.properties.gdpPerCap} USD
            <br/>
            Democracy Ranking: {tooltipInfo.feature.properties.demoRank === null ? "无" : tooltipInfo.feature.properties.demoRank}
            <br/>
            Democracy Index: {tooltipInfo.feature.properties.demoIndex === null ? "无" : tooltipInfo.feature.properties.demoIndex}
            <br/>
            Fair Elections Index: {tooltipInfo.feature.properties.equalIndex === null ? "无" : tooltipInfo.feature.properties.equalIndex}
            <br/>
            Democracy Category: {tooltipInfo.feature.properties.classification === null ? "无" : tooltipInfo.feature.properties.classification}
            <br/>
            Election Date: {tooltipInfo.feature.properties.date}
            {/* <br/>
            { (tooltipInfo.feature.properties.president === 1 || tooltipInfo.feature.properties.parliament  === 1 || tooltipInfo.feature.properties.presidential_parliament  === 1) && (
              <span>
                选举类型: {`${tooltipInfo.feature.properties.president === 1 ? "总统大选" : ""}${tooltipInfo.feature.properties.parliament === 1 ? "国会大选" : ""}${tooltipInfo.feature.properties.presidential_parliament === 1 ? "立法选举" : ""}`}
              </span>
            )} */}
          </Popup>
        )}
        {/* <Legend /> */}
        <Legend legendConfigs={legendConfigs[currentProperty]} />
      </Map>
      {geojson && <AreaChart geojson={geojson} currentProperty={currentProperty} isChecked={isChecked} ref={tooltipRef} currentCategory={currentCategory} />}
    </div>
    <div ref={tooltipRef} className="tooltip" style={{ position: 'absolute', display: 'none', pointerEvents: 'none', backgroundColor: 'white', border: '1px solid #ddd', padding: '10px 10px 15px', borderRadius: '3px', boxShadow: '0 1px 2px rgba(0, 0, 0, .1)', fontSize: '12px' }}></div>
  </>
  );
}

export default MapChart;